<template>
  <div
    class="flex w-full relative"
    :class="wrapperStyle()"
    data-test-id="badge"
  >
    <img
      src="/_nuxt3-static/widgets/badge-shape.svg"
      alt="badge shape"
      class="absolute z-0 w-[104px]"
    />
    <WidgetBadge
      data-test-id="widget-badge"
      class="z-99 p-2.5 relative md:p-3 items-center cursor-default w-fit mt-1"
      :partner-name="partnerData.name"
      :partner-link="fullLocalizedUrl(`/p/${partnerId}`)"
      :average-rating="partnerData.avg_review"
    />
  </div>
</template>

<script lang="ts" setup>
import type { KftApiDefaultResponse } from '~/composables/types/kft-api'
import type { Supplier } from '~/composables/types/event'

const route = useRoute()
const fullLocalizedUrl = useFullLocalizedUrl()

const partnerId = route.params.partnerId

definePageMeta({
  layout: 'blank',
})

const { data: partnerResponse = undefined } = await useKftApiFetch<
  KftApiDefaultResponse<Supplier>,
  {
    avg_review: number
    name: string
  }
>(`v1/store/supplier/${partnerId}`, {
  transform: (data) => {
    return {
      name: data?.data?.name,
      avg_review: data?.data?.avg_review,
    }
  },
})

const partnerData: Supplier | undefined = partnerResponse?.value

if (!partnerData) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Page Not Found',
  })
}

const wrapperStyle = () => {
  switch (route.query?.align) {
    case 'left':
      return `justify-start`
    case 'right':
      return `justify-end`
    default:
      return `justify-center`
  }
}
</script>
